export interface BankOption {
  name: string;
  minNum: number;
  maxNum: number;
}

export const starterPages: string[] = [
  // 'email-verification',
  'store-type',
  'store-owner',
  // 'business-hours',
  // 'store-details',
  // 'pickup-address',
  'address-info',
  'account-details',
];

export const bankOptions: BankOption[] = [
  { name: 'Banco De Oro Unibank, Inc.', minNum: 10, maxNum: 12 },
  { name: 'Bank of Commerce', minNum: 12, maxNum: 12 },
  { name: 'Bank of the Philippine Islands (BPI)', minNum: 10, maxNum: 10 },
  { name: 'China Banking Corporation', minNum: 10, maxNum: 12 },
  { name: 'China Bank Savings', minNum: 10, maxNum: 12 },
  { name: 'East West Banking Corporation', minNum: 12, maxNum: 12 },
  { name: 'GCash/G-Xchange, Inc.', minNum: 11, maxNum: 11 },
  { name: 'GoTyme Bank', minNum: 11, maxNum: 11 },
  { name: 'Land Bank of the Philippines', minNum: 10, maxNum: 10 },
  { name: 'Metropolitan Bank and Trust Company (Metrobank)', minNum: 10, maxNum: 13 },
  { name: 'Paymaya', minNum: 11, maxNum: 11 },
  { name: 'Philippine National Bank (PNB)', minNum: 10, maxNum: 12 },
  { name: 'Philippine Savings Bank (PSBank)', minNum: 12, maxNum: 12 },
  { name: 'Rizal Commercial Banking Corporation (RCBC)', minNum: 10, maxNum: 10 },
  { name: 'Seabank Philippines Inc.', minNum: 11, maxNum: 11 },
  { name: 'Security Bank Corporation', minNum: 13, maxNum: 13 },
  { name: 'Union Bank of the Philippines (UBP)', minNum: 12, maxNum: 12 },
];

// Names stored before the EN-14554 rename, mapped to their current equivalent.
const legacyBankNames: Record<string, string> = {
  'Banco de Oro (BDO)': 'Banco De Oro Unibank, Inc.',
  'China Bank': 'China Banking Corporation',
  'EastWest Bank': 'East West Banking Corporation',
  GCash: 'GCash/G-Xchange, Inc.',
  'Metrobank Philippines': 'Metropolitan Bank and Trust Company (Metrobank)',
  Maya: 'Paymaya',
  PayMaya: 'Paymaya',
  'Philippine National Bank': 'Philippine National Bank (PNB)',
  'Philippine Savings Bank': 'Philippine Savings Bank (PSBank)',
  'Rizal Commercial Bank Corporation (RCBC)': 'Rizal Commercial Banking Corporation (RCBC)',
  'Security Bank': 'Security Bank Corporation',
  'UnionBank of the Philippines': 'Union Bank of the Philippines (UBP)',
};

// Pre-selects the right option for profiles still storing a pre-rename name.
export const resolveBankName = (bankName?: string | null): string | null =>
  bankName ? legacyBankNames[bankName] ?? bankName : null;
